import script from "./DictionaryItemsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DictionaryItemsModal.vue?vue&type=script&lang=ts&setup=true"

import "./DictionaryItemsModal.vue?vue&type=style&index=0&id=963a6c5a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-963a6c5a"]])

export default __exports__